import { Backdrop, Box, CircularProgress } from "@mui/material";
import React, { useState } from "react";
import PageTitle from "../../../components/Common/PageTitle";
import PractitionerModal from "../../../components/Modals/PractitionerModal";
import MainComp from "./MainComp";
import SetUpSession from "./SetUpSession";
import {
  ConfirmationSnackbar,
  ErrorSnackbar,
} from "../../../components/Common/CustomSnackbar";
import { useQuickLinksItems } from "../../../context/QuickLinksContext";

const SessionExchange = () => {
  const [modalState, setModalState] = useState(false);
  const { sessionTab } = useQuickLinksItems();

  const [sessionComp, setSessionComp] = useState(sessionTab || "main");
  const [filterResults, setFilterResults] = useState(false);

  const [loading, setloading] = useState(false);
  const [success, setsuccess] = useState(false);
  const [errorState, seterrorState] = useState({
    error: false,
    message: "",
  });

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
      }}
    >
      <PageTitle
        title={"Session Exchange"}
        text={
          "The <b>Session Exchange</b> program, offered through <b>IGE Networking Groups</b>, provides students, and graduates the opportunity to exchange hypnotherapy sessions at no cost. This mutual support system allows participants to enhance their skills while benefiting from the expertise of others. Check here to see your session requests."
        }
        breadCrumb={sessionComp !== "main" && "Set Up Sessions"}
        breadCrumbOnClick={() => setSessionComp("main")}
        noIcon
        back={sessionComp !== "main"}
        onBackClick={() => setSessionComp("main")}
        videoUrl={
          "https://drive.google.com/file/d/1b4G2BJ1LnaCx645Vs4AGJ_kF1RyTfZih/preview"
        }
      />

      {sessionComp === "main" ? (
        <MainComp
          setModalState={setModalState}
          setSessionComp={setSessionComp}
          setFilterResults={setFilterResults}
        />
      ) : (
        <SetUpSession filterResults={filterResults} />
      )}

      <PractitionerModal
        open={modalState}
        handleClose={() => setModalState(false)}
        setSessionComp={setSessionComp}
        setloading={setloading}
        setsuccess={setsuccess}
        seterrorState={seterrorState}
      />

      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <ErrorSnackbar
        error={errorState.error}
        handleCloseError={() => seterrorState({ error: false, message: "" })}
        errorMsg={errorState.message}
      />
      <ConfirmationSnackbar
        snackbarState={success}
        handleSnackbarClose={() => setsuccess(false)}
        text={"Practitioner saved successfully"}
      />
    </Box>
  );
};

export default SessionExchange;
